/* 学习乐园 · 中国象棋棋谱复盘（/study/zhongguo-xiangqi-fupan）
 * 与国际象棋复盘同构，但**不共用一页**——规则、引擎、记谱互不通用：
 *   - 引擎直接复用对战页内置的 STXiangqi（footer 按引擎档先载入 game-zhongguo-xiangqi.js）；
 *   - 输入是本站导出/复制的中英混合文本：带 a1~i10 坐标的行优先采用，纯中文纵线记谱反查。
 *     中国象棋没有像 PGN 那样的事实标准，不冒充统一格式；
 *   - 分析口径同国象复盘：每个局面用进阶档（level 2）算一次最强应着分，
 *     相邻分差 = 这一步亏的（厘），报告只把亏得明显的（约 0.8 个兵以上）当结论。
 *     ANALYZE_TIME 把单局面预算从 900ms 调到 450ms：复盘是 N+1 次搜索的乘法，
 *     省的是分钟级；迭代加深保证「算不完就退回上一完整层」，深度 3 的结论不变。
 *   - 同一次搜索顺带存 bests[i]（引擎建议着）与 tops[i]（top-3 候选与分差）——
 *     「亏了多少」之外还要说「该走哪」；「看变化」（PV 主变）点开才算，不进主循环。
 * 全程在浏览器本地完成：解析、搜索、报告都不发网络请求。 */
(function (global) {
  'use strict';

  var doc = global.document;
  var root = doc.querySelector('[data-st-zhongguo-xiangqi-fupan]');
  if (!root || !doc.querySelector('[data-st-board]')) { return; }

  var E = null;          // STXiangqi（boot 时取）
  var UI = null;
  var MATE = 100000;
  var ANALYZE_LEVEL = 2;  // 与对战页「提示」同档（进阶），口径一致
  var REPORT_MIN = 80;    // 结论门槛：0.8 个兵（1 兵 = 100 厘），同国象复盘
  var KIND_MIN = { blunder: 180, mistake: 80, inaccuracy: 35 };

  var STORE_KEY = 'study-zhongguo-xiangqi-fupan-report';
  var HANDOFF_KEY = 'study-zhongguo-xiangqi-fupan-handoff';
  var HIST_KEY = 'study-zhongguo-xiangqi-fupan-history';
  var HIST_MAX = 5;        // 最近棋谱留几盘：复盘完关页面不再「下一盘挤掉上一盘」
  var ANALYZE_TIME = 450;  // 复盘单局面预算（毫秒）：进阶档 900ms 的一半，整盘省一半时间
  var KIND_CN = { blunder: '漏着', mistake: '错着', inaccuracy: '不精确' };

  /* ---------- 状态 ---------- */
  var moves = [];        // [{f, t, san}]，f/t 是坐标序号
  var plies = [];        // [{san, mover, from, to, explain, loss, kind}]
  var scores = [];       // scores[k] = 第 k 手之前的局面分（红方视角，厘）
  var bests = [];        // bests[k] = 第 k 手之前局面里引擎的最佳着（中文记谱，「该走哪」）
  var tops = [];         // tops[k] = 同局面 top-3 候选 [{san, loss}]（loss = 与最佳的分差，厘）
  var pvs = {};          // pvs[k] = 第 k 手之前局面的主变（中文记谱数组，点「看变化」才算，缓存）
  var viewAt = null;     // null = 终局；数字 = 看到「第 viewAt+1 步之后」的局面（0 起）
  var analyzed = false;
  var analyzing = false;
  var replayTimer = null;
  var paintedPly = null;
  var savedNote = '';
  var setStatus = function () {};

  var SVG_NS = 'http://www.w3.org/2000/svg';

  /* ---------- 音效（同国象复盘：粗木头敲击 + 提示音，偏好共用 study-chess-sound） ---------- */
  /* 手机外放响度补偿（口径统一，由 scripts/boost-sfx-mobile.mjs 批量写入）：
     手机小喇叭对 500Hz 以下钝感、超短音感知响度低——触屏设备把提示音增益翻倍、
     低于 500Hz 的音移高八度、衰减拉长；桌面/耳机维持原响度。 */
  var SFX_MOBILE = false;
  try {
    SFX_MOBILE = (global.matchMedia && global.matchMedia('(pointer: coarse)').matches) ||
      (global.navigator && global.navigator.maxTouchPoints > 0);
  } catch (e) { /* 检测不可用按桌面处理 */ }
  var SFX = (function () {
    var AC = null;
    function ok() {
      try { return (global.localStorage || {}).getItem('study-chess-sound') !== 'off'; } catch (e) { return true; }
    }
    function ctx() {
      if (!global.AudioContext && !global.webkitAudioContext) { return null; }
      if (!AC) { AC = new (global.AudioContext || global.webkitAudioContext)(); }
      return AC;
    }
    function warm() {
      var ac = ctx();
      if (ac && ac.state === 'suspended' && ac.resume) { ac.resume().catch(function () {}); }
    }
    function knock(freq, when, gain, dur) {
      var ac = ctx();
      if (!ac) { return; }
      if (SFX_MOBILE) {
        if (freq < 500) { freq *= 2; }
        gain *= 2;
        dur *= 1.5;
      }
      var o = ac.createOscillator();
      var g = ac.createGain();
      o.type = 'triangle';
      o.frequency.setValueAtTime(freq, when);
      o.frequency.exponentialRampToValueAtTime(freq * 0.5, when + dur);
      g.gain.setValueAtTime(gain, when);
      g.gain.exponentialRampToValueAtTime(0.0001, when + dur);
      o.connect(g); g.connect(ac.destination);
      o.start(when); o.stop(when + dur + 0.05);
    }
    function seq(list) {
      if (!ok()) { return; }
      var ac = ctx();
      if (!ac || ac.state !== 'running') { return; }
      var t = ac.currentTime;
      for (var i = 0; i < list.length; i++) {
        knock(list[i][0], t + (list[i][1] || 0), list[i][2] || 0.22, list[i][3] || 0.09);
      }
    }
    return {
      warm: warm,
      fromMove: function (an) {
        if (an && an.mate) { seq([[240, 0, 0.26], [660, 0.1, 0.16, 0.16], [880, 0.26, 0.16, 0.22]]); }
        else if (an && an.check) { seq([[240, 0, 0.24], [660, 0.09, 0.14, 0.16]]); }
        else if (an && an.captured) { seq([[240, 0, 0.26], [160, 0.06, 0.28, 0.11]]); }
        else { seq([[210, 0, 0.22]]); }
      }
    };
  })();

  /* ---------- 棋盘（只读，网格与点位构建 1:1 照抄对战页——
     viewBox 必须是 0 0 10 11：CSS 的 .st-xq-line 线宽 .04 是按这套单位系给的，
     换别的比例线就细到看不见；宫斜线/炮卒刻痕/楚河汉界同源） ---------- */
  // 炮位/兵（卒）位的「提手」刻痕位置（经典棋盘的开局标记，与对战页同一份）
  var MARKS = [[2, 1], [2, 7], [3, 0], [3, 2], [3, 4], [3, 6], [3, 8], [6, 0], [6, 2], [6, 4], [6, 6], [6, 8], [7, 1], [7, 7]];
  function svgLine(g, x1, y1, x2, y2, cls) {
    var l = doc.createElementNS(SVG_NS, 'line');
    l.setAttribute('x1', x1); l.setAttribute('y1', y1);
    l.setAttribute('x2', x2); l.setAttribute('y2', y2);
    l.setAttribute('class', cls || 'st-xq-line');
    g.appendChild(l);
    return l;
  }
  function buildGrid() {
    var svg = doc.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 10 11');
    svg.setAttribute('class', 'st-xq-grid');
    svg.setAttribute('aria-hidden', 'true');
    var g = doc.createElementNS(SVG_NS, 'g');
    svg.appendChild(g);
    var r, c, x, y, dx, dy;
    for (r = 0; r < 10; r++) { svgLine(g, 1, r + 1, 9, r + 1); }          // 10 条横线
    for (c = 0; c < 9; c++) {                                            // 竖线：两条边全高，其余被楚河汉界截断
      x = c + 1;
      if (c === 0 || c === 8) { svgLine(g, x, 1, x, 10); }
      else { svgLine(g, x, 1, x, 5); svgLine(g, x, 6, x, 10); }
    }
    svgLine(g, 4, 1, 6, 3); svgLine(g, 6, 1, 4, 3);                      // 九宫斜线（上下宫各两条）
    svgLine(g, 4, 8, 6, 10); svgLine(g, 6, 8, 4, 10);
    for (r = 0; r < MARKS.length; r++) {                                 // 炮位/卒位刻痕
      x = MARKS[r][1] + 1; y = MARKS[r][0] + 1;
      for (dx = -1; dx <= 1; dx += 2) {
        for (dy = -1; dy <= 1; dy += 2) {
          if ((MARKS[r][1] === 0 && dx < 0) || (MARKS[r][1] === 8 && dx > 0)) { continue; }
          svgLine(g, x + dx * 0.08, y + dy * 0.08, x + dx * 0.38, y + dy * 0.08, 'st-xq-line st-xq-tick');
          svgLine(g, x + dx * 0.08, y + dy * 0.08, x + dx * 0.08, y + dy * 0.38, 'st-xq-line st-xq-tick');
        }
      }
    }
    var t1 = doc.createElementNS(SVG_NS, 'text');                        // 楚河 漢界
    t1.setAttribute('x', '2.7'); t1.setAttribute('y', '5.7');
    t1.setAttribute('class', 'st-xq-river'); t1.setAttribute('text-anchor', 'middle');
    t1.textContent = '楚 河';
    var t2 = doc.createElementNS(SVG_NS, 'text');
    t2.setAttribute('x', '7.3'); t2.setAttribute('y', '5.7');
    t2.setAttribute('class', 'st-xq-river'); t2.setAttribute('text-anchor', 'middle');
    t2.textContent = '漢 界';
    g.appendChild(t1); g.appendChild(t2);
    return svg;
  }
  function buildBoard() {
    UI.board.textContent = '';
    UI.board.appendChild(buildGrid());
    for (var i = 0; i < 90; i++) {
      var pt = doc.createElement('span');
      pt.className = 'st-xq-pt st-xq-pt--ro';
      pt.style.setProperty('--r', String((i / 9) | 0));
      pt.style.setProperty('--c', String(i % 9));
      pt.setAttribute('data-sq', E.coordOf(i));
      /* 常驻棋子壳：有子时填字，无子时空着（背景只在 is-filled 下出现）；
         飞子动画也是对它做 transform（对战页同款机制） */
      var piece = doc.createElement('span');
      piece.className = 'st-xq-piece';
      pt.appendChild(piece);
      UI.board.appendChild(pt);
    }
  }

  /* 前 k 手之后的局面（重放，与对战页同一套路） */
  function boardAt(k) {
    var p = E.newPos();
    for (var i = 0; i < k; i++) { E.applyMove(p, { f: moves[i].f, t: moves[i].t }); }
    return p;
  }

  function renderBoard() {
    /* viewAt 口径同国象复盘：viewAt = 已应用到的着法序号（0 起），null = 终局。
       shown = 已应用的着法数；cue = plies[viewAt]，棋盘 = 该手之后的局面 */
    var shown = viewAt === null ? moves.length : viewAt + 1;
    var p = boardAt(shown);
    var cue = shown > 0 ? plies[shown - 1] : null;
    var checkSq = null;
    if (E.inCheck(p, p.turn)) { checkSq = E.coordOf(p.turn === 1 ? p.kr : p.kb); }
    var pts = UI.board.querySelectorAll('.st-xq-pt');
    for (var i = 0; i < pts.length; i++) {
      var sq = pts[i].getAttribute('data-sq');
      var v = p.b[E.coordIndex(sq)];
      var piece = pts[i].firstChild;                 // 常驻棋子壳
      pts[i].classList.remove('is-fly');             // 上一手的飞行状态一并清掉
      if (v !== 0) {
        piece.className = 'st-xq-piece ' + (v > 0 ? 'st-xq-red' : 'st-xq-black');
        piece.textContent = E.PIECE_CHAR[v];         // 红帥/黑將、黑砲等传统牌面由引擎给出
        pts[i].classList.add('is-filled');
        pts[i].setAttribute('aria-label', (v > 0 ? '红' : '黑') + E.PIECE_CHAR[v] + ' ' + sq);
      } else {
        piece.className = 'st-xq-piece';
        piece.textContent = '';
        piece.style.transform = '';
        pts[i].classList.remove('is-filled');
        pts[i].setAttribute('aria-label', sq);
      }
      pts[i].classList.toggle('is-last', !!cue && (sq === cue.from || sq === cue.to));
      pts[i].classList.toggle('is-check', sq === checkSq);
    }
    /* 与对战页同一口径：只有逐格往前推进一步才飞子，点结论条目跳转不飞 */
    if (cue && paintedPly !== null && shown === paintedPly + 1) {
      flyPiece(cue.from, cue.to);
      SFX.fromMove(cue.explain);
    }
    paintedPly = shown;
  }

  /* 走子轨迹：起点 → 落点（对战页同款机制——位移先写在棋子上、
     强制回流后挂 is-fly 再归零，过渡才会从起点滑到落点。
     之前用 --fx/--fy 自定义属性是错的：CSS 里没有消费它的规则，动画不会发生） */
  function flyPiece(fromSq, toSq) {
    if (global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
    var sq = UI.board.querySelector('[data-sq="' + toSq + '"]');
    var from = UI.board.querySelector('[data-sq="' + fromSq + '"]');
    if (!sq || !from) { return; }
    var piece = sq.firstChild;
    if (!piece) { return; }
    var dx = parseInt(from.style.getPropertyValue('--c'), 10) - parseInt(sq.style.getPropertyValue('--c'), 10);
    var dy = parseInt(from.style.getPropertyValue('--r'), 10) - parseInt(sq.style.getPropertyValue('--r'), 10);
    if (!dx && !dy) { return; }
    piece.style.transform = 'translate(calc(' + dx + ' * 108.7%), calc(' + dy + ' * 108.7%))';
    sq.classList.add('is-fly');
    void sq.offsetWidth;
    piece.classList.add('is-fly');
    piece.style.transform = 'none';
  }

  /* ---------- 行子列表（红方/黑方两列，口径同国象复盘） ---------- */
  function el(tag, cls, text) {
    var n = doc.createElement(tag);
    if (cls) { n.className = cls; }
    if (text != null) { n.textContent = text; }
    return n;
  }
  function span(cls, text) { return el('span', cls, text); }
  function renderMoves() {
    var box = UI.moves;
    box.textContent = '';
    if (!plies.length) { return; }
    var head = el('li', 'st-move-row st-move-row--head');
    head.appendChild(span('st-move-no', '#'));
    head.appendChild(span('st-move-col', '红方'));
    head.appendChild(span('st-move-col', '黑方'));
    box.appendChild(head);
    for (var i = 0; i < plies.length; i += 2) {
      var row = el('li', 'st-move-row');
      row.appendChild(span('st-move-no', (i / 2 + 1) + '.'));
      for (var k = 0; k < 2; k++) {
        var idx = i + k;
        if (idx >= plies.length) { row.appendChild(el('span', 'st-move-ply')); continue; }
        var p = plies[idx];
        var b = el('button', 'st-move-ply');
        b.type = 'button';
        b.textContent = p.san;
        b.setAttribute('data-ply', String(idx));
        if (p.loss >= REPORT_MIN) { b.className += ' is-lose'; }
        if (viewAt === idx) { b.className += ' is-cur'; }
        b.title = (p.mover === 1 ? '红方 · ' : '黑方 · ') + phrasesText(p);
        b.addEventListener('click', onPly);
        row.appendChild(b);
      }
      box.appendChild(row);
    }
  }
  function onPly(e) {
    if (replayTimer) { stopReplay(); }
    var idx = Number(e.currentTarget.getAttribute('data-ply'));
    viewAt = (idx === plies.length - 1 || viewAt === idx) ? null : idx;
    renderAll();
  }
  function stepPly(dir) {
    if (analyzing || !analyzed) { return; }
    stopReplay();
    var d = viewAt === null ? plies.length - 1 : viewAt;
    var n = d + dir;
    if (n < 0) { return; }
    viewAt = (n >= plies.length - 1) ? null : n;
    renderAll();
  }

  /* 「回放这局」：0.75 秒/步从开局重演（口径同对战页 750ms）；再点 = 停止并回到终局 */
  function stopReplay() {
    if (replayTimer) { global.clearInterval(replayTimer); replayTimer = null; }
    if (UI.replayLabel) { UI.replayLabel.textContent = '回放这局'; }
  }
  function toggleReplay() {
    if (analyzing || !analyzed) { return; }
    if (replayTimer) { stopReplay(); renderAll(); return; }
    viewAt = 0;
    renderAll();
    replayTimer = global.setInterval(function () {
      if (viewAt === null || viewAt >= plies.length - 1) { stopReplay(); viewAt = null; renderAll(); return; }
      viewAt++;
      renderAll();
    }, 750);
    if (UI.replayLabel) { UI.replayLabel.textContent = '停止回放'; }
  }

  /* ---------- 评估条（近似胜率）/ 状态 / 按钮 ---------- */
  /* 数字换成胜率：对初学者「红 63%」比「+0.8」好读得多。换算与条宽同一条 logistic 曲线，
     浅引擎的分本来就有噪声，所以悬停提示里写明「近似」并附厘兵原值。 */
  function renderEval() {
    var idx = viewAt === null ? scores.length - 1 : viewAt + 1;
    var s = scores.length ? scores[idx] : 0;
    if (typeof s !== 'number') { s = 0; }
    var pct = 1 / (1 + Math.exp(-Math.max(-2000, Math.min(2000, s)) / 300));
    UI.evalFill.style.width = (pct * 100).toFixed(1) + '%';
    if (Math.abs(s) >= MATE / 2) {
      UI.evalNum.textContent = s > 0 ? '红胜 100%（将杀/困毙）' : '黑胜 100%（将杀/困毙）';
      UI.evalNum.title = '将杀 / 困毙 / 限着满：结果已定';
      return;
    }
    var redPct = Math.round(pct * 100);
    UI.evalNum.textContent = (redPct >= 50 ? '红 ' : '黑 ') + Math.max(redPct, 100 - redPct) + '%';
    var pawns = s / 100;
    UI.evalNum.title = '近似胜率（本地引擎分换算，约 ' + (pawns >= 0 ? '+' : '−')
      + Math.abs(pawns).toFixed(1) + ' 兵）——浅引擎的换算仅供参考';
  }
  function renderStatus() {
    var box = UI.viewStatus;
    box.className = 'st-status';
    if (analyzing) {
      box.textContent = '分析中：每个局面都要算一次最强应着，走完为止。';
      return;
    }
    if (!analyzed) {
      box.textContent = '还没有分析结果：粘入棋谱点「开始分析」，或从对战页点「复盘这一局」过来。';
      return;
    }
    if (replayTimer) {
      box.textContent = '回放中：重演到第 ' + (viewAt + 1) + ' / ' + plies.length + ' 手。';
      return;
    }
    if (viewAt !== null) {
      var p = plies[viewAt];
      box.textContent = '回看第 ' + (viewAt + 1) + ' / ' + plies.length + ' 手（'
        + (p.mover === 1 ? '红方' : '黑方') + ' ' + p.san + '）之后的局面。';
      return;
    }
    var last = plies[plies.length - 1];
    box.textContent = moves.length >= 2 && last && last.explain && last.explain.mate
      ? '终局：' + (last.mover === 1 ? '红方' : '黑方') + '胜——对方无子可走（将杀或困毙），共 ' + plies.length + ' 步。'
      : '终局：共 ' + plies.length + ' 步。';
  }
  function renderButtons() {
    var ready = analyzed && !analyzing;
    var d = viewAt === null ? plies.length - 1 : viewAt;
    UI.prev.disabled = !ready || d <= 0;
    UI.next.disabled = !ready || viewAt === null;
    UI.replay.disabled = !ready || plies.length === 0;
    UI.analyze.disabled = analyzing;
    if (UI.reportCopy) { UI.reportCopy.disabled = !ready; }
    if (UI.reportDownload) { UI.reportDownload.disabled = !ready; }
  }

  /* ---------- 复盘结论 ---------- */
  /* 厘 → 个兵，保留 1 位；≥1000 加千位分隔（「1000.0」不好读，「1,000.0」一眼有数） */
  function pawnsText(centis) {
    var s = (Math.round(centis / 10) / 10).toFixed(1);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
  function lossText(p) {
    /* 大额分差只可能是「走子方自己走进被将杀/困毙」（将杀对方的那步分差为 0 或为正，不会进这里） */
    if (p.loss >= MATE / 2) { return '这步之后被将杀或困毙'; }
    if (p.loss <= 0) { return '没亏'; }
    return '亏 ' + pawnsText(p.loss) + ' 个兵';
  }
  function classify(loss) {
    if (loss >= KIND_MIN.blunder) { return 'blunder'; }
    if (loss >= KIND_MIN.mistake) { return 'mistake'; }
    if (loss >= KIND_MIN.inaccuracy) { return 'inaccuracy'; }
    return null;
  }
  function firstPhrase(p) {
    var ph = p.explain && p.explain.phrases ? p.explain.phrases : [];
    if (!ph.length) {
      /* 静态五项看不出、但搜索分差大 = 亏在后续手段（对方有强手），如实说而不是硬编理由 */
      if (p.loss >= REPORT_MIN) { return '静态五项看不出亏在哪——这一步亏在对方的后续手段'; }
      return '五项评估基本没变';
    }
    return ph[0];
  }
  function phrasesText(p) {
    var ph = p.explain && p.explain.phrases ? p.explain.phrases : [];
    return lossText(p) + '：' + (ph.length ? ph.join('；') : '平静的调动，五项评估基本没变');
  }

  /* ---------------- 「该走哪」：建议着 + 备选 + 变化线（口径同国象复盘） ----------------
     数据来自 analyze 时同一次搜索（bests/tops）与按需的 pvLine——
     「亏了多少」和「该怎么改」出自同一份计算，不另说一套。 */
  function buildSuggestion(j, p) {
    var box = el('div', 'st-report-best');
    var best = bests[j];
    if (best) {
      if (best === p.san) {
        // 你走的恰是引擎首选，分差来自相邻两次浅搜索的噪声——如实说，不让人白改
        box.appendChild(span('st-report-best-line', '引擎也选了这一手——上面的分差多半是浅算的噪声，不用改。'));
      } else {
        box.appendChild(span('st-report-best-line', '引擎建议：' + best));
        var alts = [];
        var topsList = tops[j] || [];
        for (var i = 0; i < topsList.length && alts.length < 2; i++) {
          var t = topsList[i];
          if (t.san !== best && t.san !== p.san) {
            alts.push(t.san + (t.loss > 0 ? '（差 ' + (t.loss / 100).toFixed(1) + '）' : '（并列）'));
          }
        }
        if (alts.length) { box.appendChild(span('st-report-alt', '备选：' + alts.join('、'))); }
      }
    } else if (analyzing) {
      box.appendChild(span('st-report-best-line', '引擎建议随分析补上……'));
    } else {
      // 恢复的旧报告：建议在后台逐个补算（hydrateSuggestions），到一条显一条
      box.appendChild(span('st-report-best-line', '引擎建议算好后出现在这里……'));
    }
    /* 变化线：点开才算一次（几百毫秒），算过就缓存；浅引擎的主变展示 2~3 步，如实不冒充证明 */
    var pvBtn = el('button', 'st-report-pv-btn');
    pvBtn.type = 'button';
    var pvLine = el('span', 'st-report-pv-line');
    if (pvs[j] && pvs[j].length) {
      pvLine.textContent = pvs[j].join(' ');
      pvLine.hidden = false;
      pvBtn.textContent = '收起变化';
    } else {
      pvLine.hidden = true;
      pvBtn.textContent = pvs[j] ? '变化算不出（超时）' : '看变化';
    }
    pvBtn.addEventListener('click', function () {
      if (pvs[j]) {
        pvLine.hidden = !pvLine.hidden;
        pvBtn.textContent = pvLine.hidden ? '看变化' : '收起变化';
        return;
      }
      pvBtn.disabled = true;
      pvBtn.textContent = '算变化中……';
      global.setTimeout(function () {
        var p = boardAt(j);
        var line = E.pvLine(p, ANALYZE_LEVEL);
        pvs[j] = line;
        pvBtn.disabled = false;
        if (line.length) {
          pvLine.textContent = line.join(' ');
          pvLine.hidden = false;
          pvBtn.textContent = '收起变化';
        } else {
          pvBtn.textContent = '变化算不出（超时）';
        }
      }, 30);
    });
    box.appendChild(pvBtn);
    box.appendChild(pvLine);
    return box;
  }

  /* ---------------- 教练的话（本地聚合，句句有据） ----------------
     不接任何大模型：每句话都由本盘数据（分差、分档、阶段、评估项、建议着）模板生成，
     不会编账；语气刻意带人味、以鼓励收尾——复盘不该只有红叉，还得有「下一步改什么」。 */
  var PHASE_CN = ['前段', '中段', '后段'];
  var REASON_CN = {
    material: '丢子换子吃亏', threats: '有子悬着没人保', kingSafety: '自家宫门太薄',
    position: '车马炮的点位吃亏', pawns: '兵卒阵线吃亏'
  };
  function coachStats() {
    var N = plies.length;
    var b1 = Math.max(1, Math.round(N / 3)), b2 = Math.max(b1 + 1, Math.round(N * 2 / 3));
    function mk() {
      return { blunder: 0, mistake: 0, loss: 0, phCnt: [0, 0, 0], phLoss: [0, 0, 0], reasons: {}, worst: null, worstIdx: -1 };
    }
    var st = { 1: mk(), '-1': mk() };
    for (var i = 0; i < plies.length; i++) {
      var p = plies[i];
      if (p.loss < REPORT_MIN) { continue; }
      var s = st[p.mover];
      if (!s) { continue; }
      if (p.kind === 'blunder') { s.blunder++; } else if (p.kind === 'mistake') { s.mistake++; }
      s.loss += p.loss;
      var ph = i < b1 ? 0 : (i < b2 ? 1 : 2);
      s.phCnt[ph]++; s.phLoss[ph] += p.loss;
      var d = p.explain && p.explain.deltas;
      if (d) {
        var keys = ['material', 'threats', 'kingSafety', 'position', 'pawns'];
        var bad = null, bv = 0;
        for (var k = 0; k < keys.length; k++) {
          var v = d[keys[k]];
          if (typeof v === 'number' && v < 0 && -v > bv) { bad = keys[k]; bv = -v; }
        }
        if (bad) { s.reasons[REASON_CN[bad]] = (s.reasons[REASON_CN[bad]] || 0) + 1; }
      }
      if (!s.worst || p.loss > s.worst.loss) { s.worst = p; s.worstIdx = i; }
    }
    return st;
  }
  function coachRound(k) { return Math.floor(k / 2) + 1; }
  function sideName(c) { return c === 1 ? '红方' : '黑方'; }
  function buildCoach() {
    var st = coachStats();
    var entries = st[1].blunder + st[1].mistake + st['-1'].blunder + st['-1'].mistake;
    var lines = [];
    if (!entries) {
      lines.push('这盘棋在这个引擎眼里下得很干净：双方都没有亏到 0.8 个兵以上的着法。'
        + '能把平静的局面走得稳，本身就是功夫——想再进一步，拿一盘输给更强对手的棋来复盘，收获更大。');
      return lines;
    }
    /* 总评：谁的亏分重、集中在哪一段（thirds 分段如实叫前/中/后段，不冒充开局残局理论）。
       双方总亏分完全相等时不能说「比对方重」——如实说打平。 */
    var tie = st[1].loss === st['-1'].loss;
    var more = st[1].loss >= st['-1'].loss ? 1 : -1;
    var sM = st[more], sO = st[-more];
    var phase = 0;
    for (var i = 1; i < 3; i++) { if (sM.phLoss[i] > sM.phLoss[phase]) { phase = i; } }
    var openers = ['先说最要紧的：', '整盘扫完，结论是：', '这盘棋的账是这样的：'];
    lines.push(openers[plies.length % openers.length] + (tie
      ? '双方亏分打成平手（各约 ' + pawnsText(sM.loss) + ' 个兵）'
      : sideName(more) + '一共亏了约 ' + pawnsText(sM.loss) + ' 个兵，比' + sideName(-more)
        + '（约 ' + pawnsText(sO.loss) + ' 个兵）重')
      + '；亏分最集中在' + PHASE_CN[phase]
      + (sM.phCnt[phase] > 1 ? '，' + sM.phCnt[phase] + ' 处里占了大头' : '') + '。');
    /* 重复出现的问题优先讲——同一个坑摔两次就是习惯了 */
    var reason = null, rc = 0;
    for (var r in sM.reasons) { if (sM.reasons[r] > rc) { reason = r; rc = sM.reasons[r]; } }
    if (reason && rc >= 2) {
      lines.push('这些亏分里有一个反复出现的问题——' + reason + '（' + rc + ' 处）。'
        + '把它挑出来改，比多背十个开局都有用。');
    } else if (sM.worst) {
      var best = bests[sM.worstIdx];
      lines.push('最值得重摆的是第 ' + coachRound(sM.worstIdx) + ' 回合的 ' + sM.worst.san
        + (best && best !== sM.worst.san ? '——引擎建议走 ' + best : '')
        + '。把那一步前后多看两眼，胜过把整盘重下三遍。');
    }
    /* 亮点：只夸数据撑得住的 */
    var praise = [];
    if (sO.blunder === 0) { praise.push(sideName(-more) + '整盘没有漏着，稳定性值得保持'); }
    if (sO.loss > 0 && sO.phCnt[2] === 0) { praise.push(sideName(-more) + '后段一步都没亏，越下越稳'); }
    if (praise.length) { lines.push('好消息也有：' + praise.join('；') + '。'); }
    lines.push('复盘不是找罪受：从错着清单里挑一条，按「引擎建议」摆一遍——下一盘改掉一件事，就算这趟复盘没白做。');
    return lines;
  }
  function renderCoach() {
    if (!UI.coach) { return; }
    if (!analyzed) { UI.coach.hidden = true; UI.coach.textContent = ''; return; }
    var lines = buildCoach();
    UI.coach.textContent = '';
    UI.coach.appendChild(el('h4', 'st-coach-title', '教练的话'));
    for (var i = 0; i < lines.length; i++) { UI.coach.appendChild(el('p', 'st-coach-line', lines[i])); }
    UI.coach.hidden = false;
  }

  /* ---------------- 报告导出（复制 / 下载 .txt）——分享出去也是免费替本页说话 ---------------- */
  function reportText() {
    var L = [];
    var count = { 1: { blunder: 0, mistake: 0 }, '-1': { blunder: 0, mistake: 0 } };
    var worst = null, worstIdx = -1;
    for (var i = 0; i < plies.length; i++) {
      var p = plies[i];
      if (p.loss >= REPORT_MIN && count[p.mover][p.kind] !== undefined) { count[p.mover][p.kind]++; }
      if (!worst || p.loss > worst.loss) { worst = p; worstIdx = i; }
    }
    L.push('学习乐园 · 中国象棋复盘报告');
    L.push('生成时间：' + new Date().toLocaleString());
    L.push('规模：' + Math.ceil(plies.length / 2) + ' 回合（本地引擎分析，棋谱未上传）');
    L.push('红方：漏着 ' + count[1].blunder + ' · 错着 ' + count[1].mistake
      + '　黑方：漏着 ' + count['-1'].blunder + ' · 错着 ' + count['-1'].mistake);
    if (worst && worst.loss >= REPORT_MIN) {
      L.push('转折：第 ' + coachRound(worstIdx) + ' 回合（' + sideName(worst.mover) + ' ' + worst.san + '）');
    }
    L.push('');
    L.push('—— 错着清单 ——');
    for (var j = 0; j < plies.length; j++) {
      var p2 = plies[j];
      if (p2.loss < REPORT_MIN) { continue; }
      L.push('第 ' + coachRound(j) + ' 回合 ' + sideName(p2.mover) + ' ' + p2.san
        + '：' + lossText(p2) + '（' + KIND_CN[p2.kind] + '）');
      var ph = p2.explain && p2.explain.phrases ? p2.explain.phrases : [];
      if (ph.length) { L.push('  原因：' + ph.join('；')); }
      var best = bests[j];
      if (best && best !== p2.san) {
        L.push('  引擎建议：' + best);
        var topsList = tops[j] || [];
        var alts = [];
        for (var k = 0; k < topsList.length && alts.length < 2; k++) {
          var t = topsList[k];
          if (t.san !== best && t.san !== p2.san) { alts.push(t.san + (t.loss > 0 ? '（差 ' + (t.loss / 100).toFixed(1) + '）' : '（并列）')); }
        }
        if (alts.length) { L.push('  备选：' + alts.join('、')); }
      }
      if (pvs[j] && pvs[j].length) { L.push('  变化：' + pvs[j].join(' ')); }
    }
    L.push('');
    L.push('—— 教练的话 ——');
    var coach = buildCoach();
    for (var c = 0; c < coach.length; c++) { L.push(coach[c]); }
    L.push('');
    L.push('口径：本地引擎每步约 3 层，亏分门槛 0.8 个兵；平静着法的小分差仅供参考。');
    return L.join('\n');
  }
  function fileStamp() {
    var d = new Date();
    function p2(n) { return (n < 10 ? '0' : '') + n; }
    return d.getFullYear() + p2(d.getMonth() + 1) + p2(d.getDate()) + '-' + p2(d.getHours()) + p2(d.getMinutes());
  }
  function copyReport() {
    if (!analyzed || analyzing) { return; }
    var text = reportText();
    var fail = function () {
      var ta = doc.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      doc.body.appendChild(ta);
      ta.select();
      try { ta.setSelectionRange(0, text.length); } catch (e2) { /* 老浏览器无所谓 */ }
      var okCopy = false;
      try { okCopy = doc.execCommand('copy'); } catch (e3) { okCopy = false; }
      /* execCommand 被拒时返回 false 而不抛异常，必须看返回值，否则明明没复制成功也说复制了 */
      setStatus(okCopy ? '报告已复制，去粘贴吧。' : '复制被浏览器拦了——试试「下载报告」。');
      doc.body.removeChild(ta);
    };
    if (global.navigator && global.navigator.clipboard && global.navigator.clipboard.writeText) {
      global.navigator.clipboard.writeText(text).then(function () { setStatus('报告已复制，去粘贴吧。'); }, fail);
    } else { fail(); }
  }
  function downloadReport() {
    if (!analyzed || analyzing) { return; }
    var blob = new Blob([reportText()], { type: 'text/plain;charset=utf-8' });
    var a = doc.createElement('a');
    a.href = global.URL.createObjectURL(blob);
    a.download = '学习乐园-中国象棋复盘-' + fileStamp() + '.txt';
    doc.body.appendChild(a);
    a.click();
    doc.body.removeChild(a);
    global.setTimeout(function () { global.URL.revokeObjectURL(a.href); }, 2000);
    setStatus('报告已下载成 .txt——存档、发群都行。');
  }

  /* ---------------- 最近复盘的棋局（本机最近 5 盘，载入即回看） ---------------- */
  function renderGames() {
    if (!UI.games || !UI.gamesList) { return; }
    var list = loadHistory();
    if (UI.gamesCount) { UI.gamesCount.textContent = list.length ? String(list.length) : ''; }
    disarmDel();
    UI.gamesList.textContent = '';   // 先清旧条目：删掉最后一条后不留过期 DOM
    if (!list.length) { UI.games.hidden = true; return; }
    UI.games.hidden = false;
    for (var i = 0; i < list.length; i++) {
      (function (entry, idx) {
        var li = el('li', 'st-games-item');
        var d = new Date(entry.t || Date.now());
        function p2(n) { return (n < 10 ? '0' : '') + n; }
        // 日期主行说人话：今天/昨天用相对词，更早回退「9月28日」——比 10-1 这种数字串好读。
        // 按日历日判断而不是 24 小时差：凌晨的棋到上午打开也该算「昨天」
        var now = new Date();
        var day0 = function (x) { return new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime(); };
        var diff = Math.round((day0(now) - day0(d)) / (24 * 3600 * 1000));
        var hm = p2(d.getHours()) + ':' + p2(d.getMinutes());
        var when;
        if (diff <= 0) { when = '今天 ' + hm; }
        else if (diff === 1) { when = '昨天 ' + hm; }
        else { when = (d.getMonth() + 1) + '月' + d.getDate() + '日 ' + hm; }
        // 主副两层：日期时间是扫读主键（深色），「走了 N 回合」是次要信息（浅色小字）
        var label = el('span', 'st-games-label');
        label.appendChild(span('st-games-date', when));
        label.appendChild(span('st-games-meta', '走了 ' + Math.ceil((entry.moves || []).length / 2) + ' 回合'));
        li.appendChild(label);
        // 整条可点：点条目任意处加载（鼠标点「加载」/ 键盘 Enter 都靠 click 冒泡到这里，不重复绑）；
        // 删除按钮有自己的语义，stopPropagation 拦住不让它顺带触发载入
        li.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('.st-games-del')) { return; }
          loadHistoryGame(idx);
        });
        var btn = el('button', 'st-games-open');
        btn.type = 'button';
        btn.textContent = '加载';
        btn.setAttribute('aria-label', '加载 ' + when + ' 的那盘棋');
        li.appendChild(btn);
        var del = el('button', 'st-games-del');
        del.type = 'button';
        del.textContent = '删除';
        del.setAttribute('data-aria-rest', '删除 ' + when + ' 那盘的本机记录');
        del.setAttribute('aria-label', del.getAttribute('data-aria-rest'));
        del.addEventListener('click', function (e) {
          e.stopPropagation();
          if (armedDel === del) { disarmDel(); removeHistoryGame(idx); return; }
          disarmDel();
          armedDel = del;
          del.textContent = '确认删除？';
          del.classList.add('st-games-del--armed');
          del.setAttribute('aria-label', '再点一次确认：' + del.getAttribute('data-aria-rest'));
          armedDelTimer = setTimeout(disarmDel, 3000);
        });
        li.appendChild(del);
        UI.gamesList.appendChild(li);
      })(list[i], i);
    }
  }
  function loadHistoryGame(idx) {
    if (analyzing) { return; }
    var entry = loadHistory()[idx];
    if (!entry || !entry.moves || !entry.losses) { return; }
    stopReplay();
    if (!buildFromCoordLoss(entry.moves, entry.losses)) {
      setStatus('这一盘的存档与规则对不上（可能被改动过），载不了。');
      return;
    }
    UI.pgn.value = textFromMoves();
    savedNote = '已加载最近的一盘（' + plies.length + ' 步）。粘入新棋谱可重新分析。';
    renderAll();
    hydrateSuggestions();
  }
  /** 删除做内联两步确认：第一击按钮就地变「确认删除？」，再击才真删，3 秒不动自动复位。
      误删的代价是整段本机分析记录，弹窗太重、一点就删太轻。armed 状态随重渲染/换目标清掉。 */
  var armedDel = null;
  var armedDelTimer = 0;
  function disarmDel() {
    if (armedDelTimer) { clearTimeout(armedDelTimer); armedDelTimer = 0; }
    if (armedDel) {
      armedDel.textContent = '删除';
      armedDel.classList.remove('st-games-del--armed');
      armedDel.setAttribute('aria-label', armedDel.getAttribute('data-aria-rest') || '');
      armedDel = null;
    }
  }
  /** 删除「最近复盘的棋局」里的一条——只删本机记录，不影响当前画布与已下载的报告；须经内联确认后调用 */
  function removeHistoryGame(idx) {
    if (analyzing) { return; }
    var list = loadHistory();
    if (idx < 0 || idx >= list.length) { return; }
    list.splice(idx, 1);
    try { global.localStorage.setItem(HIST_KEY, JSON.stringify(list)); } catch (e) { /* 存不进就算了 */ }
    renderGames();
  }
  function renderReport() {
    var listBox = UI.reportList;
    listBox.textContent = '';
    if (!analyzed) {
      UI.reportCounts.textContent = analyzing ? '分析中……' : '分析完成后出结论。';
      return;
    }
    var count = { r: { blunder: 0, mistake: 0 }, b: { blunder: 0, mistake: 0 } };
    var worst = null;
    for (var i = 0; i < plies.length; i++) {
      var p = plies[i];
      if (p.loss >= REPORT_MIN && count[p.mover === 1 ? 'r' : 'b'][p.kind] !== undefined) {
        count[p.mover === 1 ? 'r' : 'b'][p.kind]++;
      }
      if (!worst || p.loss > worst.loss) { worst = p; }
    }
    var turnLine = '红方：漏着 ' + count.r.blunder + ' · 错着 ' + count.r.mistake
      + '　黑方：漏着 ' + count.b.blunder + ' · 错着 ' + count.b.mistake;
    if (worst && worst.loss >= REPORT_MIN) {
      turnLine += '　转折在第 ' + (Math.floor(plies.indexOf(worst) / 2) + 1) + ' 回合（'
        + (worst.mover === 1 ? '红方' : '黑方') + ' ' + worst.san + '）';
    } else {
      turnLine += '　双方都没走出明显亏分的着法';
    }
    UI.reportCounts.textContent = turnLine;
    var any = false;
    for (var j = 0; j < plies.length; j++) {
      var p2 = plies[j];
      if (p2.loss < REPORT_MIN) { continue; }
      any = true;
      var li = el('li', 'st-report-item');
      var btn = el('button', 'st-report-btn');
      btn.type = 'button';
      btn.appendChild(span('st-report-no', (Math.floor(j / 2) + 1) + '.'));
      btn.appendChild(span('st-report-san', (p2.mover === 1 ? '红' : '黑') + p2.san));
      btn.appendChild(span('st-report-loss' + (p2.loss >= KIND_MIN.blunder ? ' st-report-loss--big' : ''), lossText(p2)));
      btn.appendChild(span('st-report-why', firstPhrase(p2)));
      btn.addEventListener('click', (function (idx) {
        return function () {
          stopReplay();
          viewAt = (idx === plies.length - 1) ? null : idx;
          renderAll();
        };
      })(j));
      li.appendChild(btn);
      li.appendChild(buildSuggestion(j, p2));   // 「该走哪」：建议着 + 备选 + 变化线
      listBox.appendChild(li);
    }
    if (!any) {
      var empty = el('li', 'st-report-empty');
      empty.textContent = '没有亏到 ' + (REPORT_MIN / 100).toFixed(1) + ' 个兵以上的着法——至少在这个引擎眼里下得干净。';
      listBox.appendChild(empty);
    }
  }

  function renderAll() {
    renderBoard();
    renderMoves();
    renderEval();
    renderStatus();
    renderButtons();
    renderReport();
    renderCoach();
    renderGames();
    if (savedNote) {
      UI.savedNote.hidden = false;
      UI.savedNote.textContent = savedNote;
      savedNote = '';
    }
    var cur = UI.moves.querySelector('.is-cur');
    if (cur && cur.scrollIntoView) { cur.scrollIntoView({ block: 'nearest' }); }
  }

  /* ---------- 棋谱解析 ----------
   * 支持三种写法（可混排），口径见页首注释：
   *   1) 导出格式：`1. 红炮 炮二平五（h3-e3）`——括号里的 a1~i10 坐标优先采用；
   *   2) 复制格式：`1. 红炮 炮二平五`——用「当前局面的合法着法记谱」反查；
   *   3) 整行就是坐标对：`h3-e3`、`b10c8`。
   * 无序号的一行一回合文本也支持，例如「炮七进四   士4退5」；末尾的红胜/黑胜/和棋等结果词会忽略。
   * 表头/说明行（不以序号开头、整行又不是坐标）若不像着法会跳过；明显像着法但当前局面不匹配时给出具体手数错误，
   * 避免原来静默只解析半盘。一手都读不到才算失败。 */
  function normCoord(x, y) {
    if (!/^[a-iA-I]$/.test(x)) { return null; }
    var n = parseInt(y, 10);
    if (!(n >= 1 && n <= 10)) { return null; }
    return x.toLowerCase() + n;
  }
  function matchSan(pos, text) {
    var list = E.legalMoves(pos);
    var best = null;
    /* 先找最靠前的合法记谱；同一位置优先较长者，避免「马二进」这类片段抢走完整着法。 */
    for (var i = 0; i < list.length; i++) {
      var san = E.toChinese(pos.b, list[i]);
      var at = san ? text.indexOf(san) : -1;
      if (at < 0) { continue; }
      if (!best || at < best.at || (at === best.at && san.length > best.san.length)) {
        best = { m: { f: list[i].f, t: list[i].t }, san: san, at: at };
      }
    }
    return best;
  }
  function parseScoreText(text) {
    var out = [];
    var pos = E.newPos();
    var lines = String(text || '').replace(/\u00a0/g, ' ').split(/\r?\n/);
    function take(fs, ts, raw) {
      var f = E.coordIndex(fs), t = E.coordIndex(ts);
      var ok = null;
      var list = E.legalMoves(pos);
      for (var i = 0; i < list.length; i++) {
        if (list[i].f === f && list[i].t === t) { ok = list[i]; break; }
      }
      if (!ok) { return '棋谱第 ' + (out.length + 1) + ' 手（' + raw + '）与规则不符，分析中止。'; }
      out.push({ f: f, t: t, san: E.toChinese(pos.b, ok) });
      E.applyMove(pos, { f: f, t: t });
      return null;
    }
    for (var li = 0; li < lines.length; li++) {
      var line = lines[li].trim();
      if (!line) { continue; }
      var numbered = /^\d+\s*[.、．]/.test(line);
      var body = line.replace(/^\d+\s*[.、．]\s*/, '');
      /* 整行就是一对坐标：h3-e3 / b10 c8 / h3e3 */
      var bare = /^([a-i])\s*(\d{1,2})\s*[-–—~]?\s*([a-i])\s*(\d{1,2})$/.exec(body);
      if (bare) {
        var a = normCoord(bare[1], bare[2]), b2 = normCoord(bare[3], bare[4]);
        if (a && b2) {
          var err = take(a, b2, a + '-' + b2);
          if (err) { return { moves: null, error: err }; }
        }
        continue;
      }
      /* 带序号的行：先找括号里的坐标对（导出格式，权威），找不到再按中文记谱反查 */
      var cm = /[（(]\s*([a-i])\s*(\d{1,2})\s*[-–—~]\s*([a-i])\s*(\d{1,2})\s*[）)]/i.exec(body);
      if (cm) {
        var fa = normCoord(cm[1], cm[2]), ta = normCoord(cm[3], cm[4]);
        if (fa && ta) {
          var err2 = take(fa, ta, fa + '-' + ta);
          if (err2) { return { moves: null, error: err2 }; }
          continue;
        }
      }
      /* 纯中文记谱（复制格式）：一行可能有多手，逐个吃掉；无序号文本也支持。 */
      var rest = body;
      if (!numbered) {
        /* 常见棋谱是一行一回合：炮七进四   士4退5。结果词只作尾注，不参与走子。 */
        var tokens = body.split(/[\s,，;；]+/).filter(Boolean);
        for (var ti = 0; ti < tokens.length; ti++) {
          var token = tokens[ti].replace(/[。.!！?？]+$/, '');
          if (/^(红|黑)?(胜|负|和棋|和|认输|结束)$/.test(token)) { continue; }
          var exact = null;
          var legalNow = E.legalMoves(pos);
          for (var ei = 0; ei < legalNow.length; ei++) {
            var es = E.toChinese(pos.b, legalNow[ei]);
            if (es === token) {
              exact = { m: { f: legalNow[ei].f, t: legalNow[ei].t }, san: es };
              break;
            }
          }
          if (!exact) {
            /* 不是结果词也不是合法着法：既然这一行明显像棋谱，就报出具体手数，
               避免当前实现静默跳过后只分析半盘。 */
            if (/^[车馬马炮砲相象仕士帅將将兵卒前后中进退平0-9一二三四五六七八九十]+$/.test(token)) {
              return { moves: null, error: '棋谱第 ' + (out.length + 1) + ' 手（' + token + '）无法按当前局面匹配。' };
            }
            continue;
          }
          var err4 = take(exact.m.f, exact.m.t, exact.san);
          if (err4) { return { moves: null, error: err4 }; }
        }
        continue;
      }
      for (;;) {
        var hit = matchSan(pos, rest);
        if (!hit) { break; }
        var err3 = take(hit.m.f, hit.m.t, hit.san);
        if (err3) { return { moves: null, error: err3 }; }
        rest = rest.slice(0, hit.at) + ' ' + rest.slice(hit.at + hit.san.length);
      }
    }
    if (!out.length) {
      return { moves: null, error: '没有读到任何着法——请粘对战页「导出」或「复制」的棋谱文本。' };
    }
    return { moves: out, error: null };
  }

  /* ---------- 分析 ----------
   * scores[k]：第 k 手之前的局面分（红方视角，厘）。
   * 有子可走 → 进阶档搜索的最佳分（换算成红方视角），同一次搜索顺带记下
   *   bests[k]（引擎建议着）与 tops[k]（top-3 候选与分差）——「亏了多少」和
   *   「该走哪」是同一份计算的两个输出；
   * 无子可走 → 轮走方判负（将杀/困毙同口径），没有建议着；自然限着满 → 和，0。 */
  /* 单例通道 + 单槽：原来每条消息 new 一个 MessageChannel，长棋谱几百个局面就是
     几百个没 close 的通道。单槽在并发两链时会丢前一条（已有代际守卫，丢的那条本来就该作废） */
  var yieldTick = (function () {
    if (typeof global.MessageChannel === 'function') {
      var ch = new global.MessageChannel();
      var pending = null;
      ch.port1.onmessage = function () {
        var f = pending;
        pending = null;
        if (f) { f(); }
      };
      return function (fn) { pending = fn; ch.port2.postMessage(0); };
    }
    return function (fn) { global.setTimeout(fn, 0); };
  })();

  function renderProgress(done, total) {
    UI.progress.hidden = false;
    UI.progressFill.style.width = Math.round(done / total * 100) + '%';
    /* 首拍附带如实预告的耗时：单局面预算 × 局面数，向上取整成秒 */
    var est = done === 1 ? '，预计约 ' + Math.max(1, Math.round(total * ANALYZE_TIME / 1000)) + ' 秒' : '';
    UI.progressText.textContent = '正在分析第 ' + done + ' / ' + total + ' 个局面'
      + est + '（全部在本地算，没有请求服务器）';
    if (done >= total) { UI.progress.hidden = true; }
  }

  function analyze(text, onFail) {
    if (analyzing) { return; }
    var parsed = parseScoreText(text);
    if (parsed.error) { onFail(parsed.error); return; }
    stopReplay();   // 回放计时器闭包读的是旧局面：换局先停，防止定时器把新局拽回旧局面
    hydrateEpoch++;   // 作废可能在飞的补算链
    analyzing = true;
    analyzed = false;
    moves = parsed.moves;
    plies = [];
    scores = [];
    bests = []; tops = []; pvs = {};
    viewAt = null;
    paintedPly = null;
    renderAll();

    var N = moves.length;
    var i = 0;
    /* 第一拍循环：每个局面搜索一次（scores[i] + 建议着 + 候选榜），随后把棋子推到下一局面 */
    function searchChunk() {
      var p = boardAt(i);
      var legal = E.legalMoves(p);
      if (!legal.length || p.half >= E.DRAW_HALF) {
        scores[i] = !legal.length ? (p.turn === 1 ? -MATE : MATE) : 0;
        bests[i] = null;   // 终局 / 限着满：没有建议着
        tops[i] = null;
      } else {
        var r = E.think(p, ANALYZE_LEVEL, ANALYZE_TIME);
        scores[i] = r.score * (p.turn === 1 ? 1 : -1);
        /* 建议着取候选榜首位（真实最佳）而非 r.move——不依赖「复盘档没开放水」的隐式前提 */
        bests[i] = (r.top && r.top.length) ? r.top[0].san : (r.move ? E.toChinese(p.b, r.move) : null);
        tops[i] = r.top || null;
      }
      i++;
      renderProgress(i, N + 1);
      if (i <= N) { yieldTick(searchChunk); }
      else { annotateChunk(); }
    }
    /* 第二轮：讲解与分差（annotate 内部 make/undo，静态评估，一拍扫完不卡） */
    function annotateChunk() {
      var pos = E.newPos();
      for (var k = 0; k < N; k++) {
        var mv = { f: moves[k].f, t: moves[k].t };
        var an = E.annotate(pos, mv);
        var dir = pos.turn === 1 ? 1 : -1;
        var loss = Math.max(0, Math.round((scores[k] - scores[k + 1]) * dir));
        plies.push({
          san: moves[k].san, mover: pos.turn,
          from: E.coordOf(mv.f), to: E.coordOf(mv.t),
          explain: an, loss: loss, kind: classify(loss)
        });
        E.applyMove(pos, mv);
      }
      analyzing = false;
      analyzed = true;
      save();
      setStatus('分析完成：结论在右侧「复盘结论」，点棋盘旁的行子或结论条目回看。');
      UI.savedNote.hidden = true;   // 重新分析后「已从本机恢复」的旧提示作废
      renderAll();
    }
    yieldTick(searchChunk);
  }

  /* ---------- 存档（同国象复盘：只存着法与亏分，讲解重算） ---------- */
  function save() {
    try {
      global.localStorage.setItem(STORE_KEY, JSON.stringify({
        v: 1,
        moves: moves.map(function (m) { return [E.coordOf(m.f), E.coordOf(m.t)]; }),
        losses: plies.map(function (p) { return p.loss; })
      }));
    } catch (e) { /* 隐身模式等存不进就算了 */ }
    saveHistory();
  }
  /* 最近棋谱：本机留最近 5 盘（坐标 + 分差，讲解载入时重算）。仍是「存本地」——
     只进这台设备的 localStorage，不上传。存不进就算了，不弹错。 */
  function saveHistory() {
    try {
      var list = loadHistory();
      var snap = {
        t: Date.now(),
        moves: moves.map(function (m) { return [E.coordOf(m.f), E.coordOf(m.t)]; }),
        losses: plies.map(function (p) { return p.loss; })
      };
      /* 同一盘棋（着法相同）无论从哪个入口重新分析，都只留最新一条——
         只跟第一条比会漏掉「从最近复盘的棋局载入旧盘再分析」的重复（列表里出现两条同棋）。 */
      var snapStr = JSON.stringify(snap.moves);
      var kept = [];
      for (var i = 0; i < list.length; i++) {
        if (JSON.stringify((list[i] || {}).moves || []) !== snapStr) { kept.push(list[i]); }
      }
      kept.unshift(snap);
      if (kept.length > HIST_MAX) { kept.length = HIST_MAX; }
      global.localStorage.setItem(HIST_KEY, JSON.stringify(kept));
    } catch (e) { /* 同上 */ }
  }
  function loadHistory() {
    try {
      var list = JSON.parse(global.localStorage.getItem(HIST_KEY) || '[]');
      return Object.prototype.toString.call(list) === '[object Array]' ? list : [];
    } catch (e) { return []; }
  }
  /** 由坐标对 + 分差重建整局（restore 与「最近复盘的棋局」载入共用）。
      bests/tops 搜索数据不在存档里，恢复后由 hydrateSuggestions 补算。 */
  function buildFromCoordLoss(coordPairs, lossesIn) {
    var list = [];
    var pos = E.newPos();
    for (var i = 0; i < coordPairs.length; i++) {
      var f = E.coordIndex(coordPairs[i][0]), t = E.coordIndex(coordPairs[i][1]);
      if (typeof f !== 'number' || typeof t !== 'number') { return false; }
      var ok = null;
      var legal = E.legalMoves(pos);
      for (var j = 0; j < legal.length; j++) {
        if (legal[j].f === f && legal[j].t === t) { ok = legal[j]; break; }
      }
      if (!ok) { return false; }
      list.push({ f: f, t: t, san: E.toChinese(pos.b, ok) });
      E.applyMove(pos, { f: f, t: t });
    }
    hydrateEpoch++;   // 换局作废还在飞的补算链（见 hydrateSuggestions 的代际守卫）
    moves = list;
    plies = [];
    scores = [];
    bests = []; tops = []; pvs = {};
    for (var k = 0; k < list.length; k++) { bests.push(null); tops.push(null); }
    pos = E.newPos();
    for (i = 0; i < list.length; i++) {
      var mv = { f: list[i].f, t: list[i].t };
      var an = E.annotate(pos, mv);
      var loss = lossesIn && typeof lossesIn[i] === 'number' ? lossesIn[i] : 0;
      plies.push({
        san: list[i].san, mover: pos.turn,
        from: E.coordOf(mv.f), to: E.coordOf(mv.t),
        explain: an, loss: loss, kind: classify(loss)
      });
      E.applyMove(pos, mv);
    }
    viewAt = null;
    paintedPly = null;
    analyzed = true;
    return true;
  }
  /** 恢复 / 载入后，给结论清单里的局面补算「引擎建议 + 备选」（每拍一个局面，不卡页面）。
      分析路径里这些数据是搜索顺带产生的，只有恢复路径缺——补齐后报告条目自动长出建议。 */
  var hydrateEpoch = 0;   // 补算链代际：换局 / 重新分析时 +1，旧链的异步结果一律作废
  function hydrateSuggestions() {
    if (!analyzed || analyzing) { return; }
    var need = [];
    for (var i = 0; i < plies.length; i++) {
      if (plies[i].loss >= REPORT_MIN && !bests[i]) { need.push(i); }
    }
    if (!need.length) { return; }
    var k = 0;
    var myEpoch = hydrateEpoch;   // 换局后 boardAt 算的已是新局面，旧链不许再写 bests[idx]
    (function step() {
      if (k >= need.length || !analyzed || myEpoch !== hydrateEpoch) {
        renderAll();
        return;
      }
      var idx = need[k++];
      var p = boardAt(idx);
      if (!E.legalMoves(p).length || p.half >= E.DRAW_HALF) {
        bests[idx] = null;
      } else {
        var r = E.think(p, ANALYZE_LEVEL, ANALYZE_TIME);
        bests[idx] = (r.top && r.top.length) ? r.top[0].san : (r.move ? E.toChinese(p.b, r.move) : null);
        tops[idx] = r.top || null;
      }
      renderAll();
      yieldTick(step);
    })();
  }
  function restore() {
    var raw = null;
    try { raw = global.localStorage.getItem(STORE_KEY); } catch (e) { /* 同上 */ }
    if (!raw) { return false; }
    var data;
    try { data = JSON.parse(raw); } catch (e) { return false; }
    if (!data || data.v !== 1 || !data.moves || !data.moves.length) { return false; }
    if (!buildFromCoordLoss(data.moves, data.losses)) { return false; }
    savedNote = '已恢复上次的分析（' + plies.length + ' 步），可继续回看或粘入新棋谱重新分析。';
    hydrateSuggestions();
    return true;
  }
  /** 用当前着法重建一份可重新解析的棋谱文本填回输入框（恢复场景） */
  function textFromMoves() {
    var out = [];
    for (var i = 0; i < moves.length; i++) {
      out.push((i + 1) + '. ' + (plies[i].mover === 1 ? '红' : '黑') + plies[i].explain.name + ' '
        + moves[i].san + '（' + E.coordOf(moves[i].f) + '-' + E.coordOf(moves[i].t) + '）');
    }
    return out.join('\n');
  }

  /* ---------- 导入 ---------- */
  function doAnalyze() {
    if (analyzing) { return; }
    var text = UI.pgn.value.replace(/\u00a0/g, ' ').trim();
    if (!text) {
      setStatus('先把棋谱文本粘进上面的框，或点「选 .txt 文件」。');
      return;
    }
    setStatus('解析成功，开始逐步分析……');
    analyze(text, setStatus);
  }
  function readFile(f) {
    if (!f) { return; }
    if (!global.FileReader) { setStatus('这个浏览器不支持本地读文件，把棋谱文本直接粘进来也一样。'); return; }
    var fr = new global.FileReader();
    fr.onload = function () {
      UI.pgn.value = String(fr.result || '');
      doAnalyze();
    };
    fr.onerror = function () { setStatus('文件读不出来（可能是空文件或编码不是文本）。'); };
    fr.readAsText(f);
  }

  /* ---------- 启动 ---------- */
  function pick(name) { return root.querySelector('[data-st-' + name + ']'); }
  function boot() {
    E = global.STXiangqi;
    if (!E) {
      /* 此时 UI 还没建、setStatus 还是空函数——直接写状态框，否则这句提示永远显示不出来 */
      var box = doc.querySelector('[data-st-status]');
      if (box) { box.textContent = '象棋引擎没有加载上（本机静态文件读取失败）。刷新一次通常就好。'; }
      return;
    }
    MATE = E.MATE;
    UI = {
      board: pick('board'), status: pick('status'), savedNote: pick('saved-note'),
      pgn: pick('pgn'), file: pick('file'), analyze: pick('analyze'),
      progress: pick('progress'), progressFill: pick('progress-fill'), progressText: pick('progress-text'),
      viewStatus: pick('view-status'), evalFill: pick('eval-fill'), evalNum: pick('eval-num'),
      moves: pick('moves'), prev: pick('prev'), next: pick('next'),
      replay: pick('replay'), replayLabel: pick('replay-label'),
      reportCounts: pick('report-counts'), reportList: pick('report-list'),
      coach: pick('coach'), reportCopy: pick('report-copy'), reportDownload: pick('report-download'),
      games: pick('games'), gamesCount: pick('games-count'), gamesList: pick('games-list')
    };
    if (!UI.board || !UI.pgn) { return; }
    setStatus = function (msg) { UI.status.textContent = msg; };

    /* 任意点击（冒泡）先热一次音频：在用户手势栈内 resume AudioContext，
       之后「回放这局」750ms 一拍的非手势推进才有声；无音频环境是空操作 */
    root.addEventListener('click', function () { SFX.warm(); });

    buildBoard();

    UI.analyze.disabled = false;
    UI.analyze.addEventListener('click', doAnalyze);
    if (UI.file) { UI.file.addEventListener('change', function (e) { readFile(e.target.files[0]); }); }
    UI.prev.addEventListener('click', function () { stepPly(-1); });
    UI.next.addEventListener('click', function () { stepPly(1); });
    UI.replay.addEventListener('click', toggleReplay);
    if (UI.reportCopy) { UI.reportCopy.addEventListener('click', copyReport); }
    if (UI.reportDownload) { UI.reportDownload.addEventListener('click', downloadReport); }

    /* 从对战页「复盘这一局」带过来的棋谱：自动填入并直接开始分析 */
    var handoff = null;
    try { handoff = global.sessionStorage.getItem(HANDOFF_KEY); } catch (e) { handoff = null; }
    if (handoff && handoff.trim()) {
      try { global.sessionStorage.removeItem(HANDOFF_KEY); } catch (e2) { /* 读得出就清，清不掉也无害 */ }
      UI.pgn.value = handoff;
      doAnalyze();
      return;
    }
    restore();
    if (analyzed) {
      UI.pgn.value = textFromMoves();
    }
    renderAll();
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(typeof window !== 'undefined' ? window : this);
